/*
 *
 * slackVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_SLACK_START, VERIFY_SLACK_SUCCESS, VERIFY_SLACK_ERROR } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const slackVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_SLACK_START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_SLACK_SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_SLACK_ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default slackVerifyReducer;
